import { render, staticRenderFns } from "./DxItem.vue?vue&type=template&id=c19591b2"
import script from "./DxItem.vue?vue&type=script&lang=js"
export * from "./DxItem.vue?vue&type=script&lang=js"
import style0 from "./DxItem.vue?vue&type=style&index=0&id=c19591b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports